import React from "react";
import PageHeader from "@/components/app/PageHeader";
import ComplianceSummaryCard from "@/pages/dashboard/ComplianceSummaryCard";

/**
 * Standalone Compliance page — features the automated briefing prominently
 * so compliance officers / PMs can jump straight to it without scrolling the
 * Dashboard.
 */
export default function Compliance() {
  return (
    <div data-testid="compliance-page">
      <PageHeader
        title="Compliance"
        subtitle="Automated daily briefing · driven by live exception signals"
      />
      <div className="p-8">
        <ComplianceSummaryCard />
        <div className="text-xs text-gray-500 font-mono leading-relaxed max-w-2xl">
          The briefing above is regenerated on demand from live signals:
          expired / expiring hauler insurance, expired / expiring driver CDLs, hazardous loads still
          in transit, loads delayed &gt; 6 hours, hauler invoices awaiting review, and stockpiles
          over capacity. For a full itemised list, visit <b>Exceptions</b>.
        </div>
      </div>
    </div>
  );
}
